import { BannersResponse } from './models';
import { createQuery } from '../../libs';
import { short_term_cashing } from '@/constants/cashing';

export const useGetBanners = createQuery<BannersResponse>(
  {
    method: 'get',
    url: 'banners',
  },
  {
    staleTime: short_term_cashing,
  }
);
